"use client";
import { jsx as a, jsxs as i } from "react/jsx-runtime";
import * as e from "@radix-ui/react-dialog";
import r from "react";
import { Close as c } from "@videoblocks/react-icons";
import { cn as s } from "./index22.mjs";
const v = ({ ...t }) => /* @__PURE__ */ a(e.Root, { "data-slot": "dialog", ...t }), D = ({ ...t }) => /* @__PURE__ */ a(e.Trigger, { "data-slot": "dialog-trigger", ...t }), g = ({ ...t }) => /* @__PURE__ */ a(e.Portal, { "data-slot": "dialog-portal", ...t }), m = ({ ...t }) => /* @__PURE__ */ a(e.Close, { "data-slot": "dialog-close", ...t }), n = r.forwardRef(({ className: t, ...o }, l) => /* @__PURE__ */ a(
  e.Overlay,
  {
    "data-slot": "dialog-overlay",
    className: s(
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/60",
      t
    ),
    ...o,
    ref: l
  }
));
n.displayName = "DialogOverlay";
const h = ({ className: t, children: o, showCloseButton: l = !0, ...d }) => /* @__PURE__ */ i(g, { "data-slot": "dialog-portal", children: [
  /* @__PURE__ */ a(n, {}),
  /* @__PURE__ */ i(
    e.Content,
    {
      "data-slot": "dialog-content",
      className: s(
        "bg-background",
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
        "fixed top-[50%] left-[50%] z-50",
        "grid w-full max-w-[calc(100%-2rem)]",
        "translate-x-[-50%] translate-y-[-50%] gap-4",
        "rounded-sm border p-6 shadow-lg",
        "duration-200 sm:max-w-lg",
        t
      ),
      ...d,
      children: [
        o,
        l && /* @__PURE__ */ i(
          m,
          {
            "data-slot": "dialog-close",
            className: `ring-offset-background focus:ring-ring
                    data-[state=open]:bg-accent data-[state=open]:text-muted-foreground
                    absolute top-8 right-4 rounded-xs
                    opacity-70 transition-opacity hover:opacity-100
                    focus:ring-2 focus:ring-offset-2 focus:outline-hidden
                    disabled:pointer-events-none [&_svg]:pointer-events-none
                    [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
            children: [
              /* @__PURE__ */ a(c, { className: "w-4 h-4 fill-current" }),
              /* @__PURE__ */ a("span", { className: "sr-only", children: "Close" })
            ]
          }
        )
      ]
    }
  )
] }), y = ({ className: t, ...o }) => /* @__PURE__ */ a(
  "div",
  {
    "data-slot": "dialog-header",
    className: s("flex flex-col gap-2 text-center sm:text-left", t),
    ...o
  }
), b = ({ className: t, ...o }) => /* @__PURE__ */ a(
  "div",
  {
    "data-slot": "dialog-footer",
    className: s("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", t),
    ...o
  }
), N = ({ className: t, ...o }) => /* @__PURE__ */ a(
  e.Title,
  {
    "data-slot": "dialog-title",
    className: s("text-lg leading-none font-semibold", t),
    ...o
  }
), w = ({
  className: t,
  ...o
}) => /* @__PURE__ */ a(
  e.Description,
  {
    "data-slot": "dialog-description",
    className: s("text-muted-foreground text-sm", t),
    ...o
  }
);
export {
  v as Dialog,
  m as DialogClose,
  h as DialogContent,
  w as DialogDescription,
  b as DialogFooter,
  y as DialogHeader,
  n as DialogOverlay,
  g as DialogPortal,
  N as DialogTitle,
  D as DialogTrigger
};
